import loadable from '@loadable/component';
import { OverlaySpinner } from '@ankr.com/ui';
import { Navigate } from 'react-router';

import { LoggingInGuard } from 'modules/auth/components/LoggingInGuard';
import { ManualLogOutGuard } from 'modules/auth/components/ManualLogOutGuard';
import { NoSSRGuard } from 'modules/common/components/NoSSRGuard';
import { Placeholder } from 'modules/common/components/Placeholder';
import { RedirectToAuthPage } from 'modules/auth/components/RedirectToAuthPage';
import { chainsRoutesConfig } from 'domains/chains/routes';
import { useAuth } from 'modules/auth/hooks/useAuth';

const HomePage = loadable(
  () => import('./HomePage').then(module => module.HomePage),
  {
    fallback: <OverlaySpinner />,
  },
);

const chainsList = chainsRoutesConfig.chains.generatePath();

export const HomePageContainer = () => {
  const { isLoggedIn } = useAuth();

  return (
    <NoSSRGuard>
      <LoggingInGuard fallback={<OverlaySpinner />}>
        <Placeholder
          hasPlaceholder={!isLoggedIn}
          placeholder={
            <ManualLogOutGuard fallback={<Navigate to={chainsList} />}>
              <RedirectToAuthPage />
            </ManualLogOutGuard>
          }
        >
          <HomePage />
        </Placeholder>
      </LoggingInGuard>
    </NoSSRGuard>
  );
};
